import OurWorkMainContent from "./OurWorkContent";

export default OurWorkMainContent;